export { default } from './Comments';



// WEBPACK FOOTER //
// ./src/components/Comment/CommentsList/index.js